var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#6B5AED",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.34 15.222c1.4 1.407 3.263 2.205 5.198 2.35a8.172 8.172 0 0 0-2.34-5.222c-1.4-1.407-3.205-2.205-5.198-2.35a8.172 8.172 0 0 0 2.34 5.222Zm11.32 0c-1.4 1.407-3.263 2.205-5.198 2.35a8.172 8.172 0 0 1 2.34-5.222C22.13 10.943 24.006 10.145 26 10c-.144 1.944-.939 3.815-2.34 5.222Zm0 5.556c-1.4-1.407-3.263-2.205-5.198-2.35a8.172 8.172 0 0 0 2.34 5.222c1.4 1.407 3.263 2.205 5.198 2.35-.144-2.002-.939-3.888-2.34-5.222Zm-11.32 0c1.4-1.407 3.263-2.205 5.27-2.35a8.172 8.172 0 0 1-2.34 5.222C13.799 25.057 11.994 25.87 10 26c.13-2.002.939-3.888 2.34-5.222Z",
    fill: "#F8FAFC",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon03);
export default __webpack_public_path__ + "static/media/company-icon-03.331bac55d91e6bc796a46c775aaf513e.svg";
export { ForwardRef as ReactComponent };